/**
 * 获取菜单
 */
export function getMenuList() {
    return [
        { text: "首页", path: 'index' },
        { text: "考试中心", path: 'exam' },
        { text: "模拟练习", path: 'practice' },
        { text: "上岗证", path: 'work-license' },
    ]
}

/**
 * 根据父菜单,获取对应的子菜单数据
 * @param {*} fatherMenu 
 */
export function getSubMenuListByFatherMenu(fatherMenu) {
    let data = []
    switch (fatherMenu) {
        case 'exam':
            // 考试中心
            data = [
                { text: "我的考试", path: "list" },
                // { text: "数据统计", path: "statistics" }
            ]
            break;
        case 'practice':
            // 模拟练习
            data = [
                { text: "我的练习", path: "list" },
                { text: "错题集", path: "mistakes" },
                { text: "我的收藏", path: "collect" }
            ]
            break;
        case 'work-license':
            // 上岗证
            data = [
                { text: "我的上岗证", path: "detalis" },
                { text: "所有上岗证", path: "record" },
            ]
            break;

        default:
            break;
    }
    return data
}